import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';
import download from 'downloadjs';

export const COMPETITION_ALL_CATEGORY_RESULTS_REQUEST = 'FETCH_COMPETITION_ALL_CATEGORY_RESULTS_REQUEST';
export const COMPETITION_ALL_CATEGORY_RESULTS_FAILURE = 'FETCH_COMPETITION_ALL_CATEGORY_RESULTS_FAILURE';
export const COMPETITION_ALL_CATEGORY_RESULTS_SUCCESS = 'FETCH_COMPETITION_ALL_CATEGORY_RESULTS_SUCCESS';

export const fetchAllCategoryResultReports = (competition) => {
    return function(dispatch) {
        dispatch(fetchRequest());

        return axios(apiRequestOptions(apiPath.REPORTS.COMPETITION_ALL_CATEGORY_RESULTS, null, {
            params: {competition},
            isBlob: true,
        }))
            .then(transformHttpResponse)
            .then(response => {
                const content = response.headers['content-type'];
                const contentDisposition = response.headers['content-disposition'] || '';
                const filenameMatch = contentDisposition.match(/filename="?([^";\s]+)"?/);
                const filename = filenameMatch ? filenameMatch[1] : 'reports.zip';
                download(response.data, filename, content);
                dispatch(fetchSuccess());
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(fetchFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const fetchRequest = () => ({type: COMPETITION_ALL_CATEGORY_RESULTS_REQUEST});
const fetchFailure = error => ({type: COMPETITION_ALL_CATEGORY_RESULTS_FAILURE, error});
const fetchSuccess = () => ({type: COMPETITION_ALL_CATEGORY_RESULTS_SUCCESS});
